import Postbox from './Postbox';
import PostboxContainer from './Postbox.container';

export default PostboxContainer(Postbox);
